import {ARRAY_PROPERTY_OPTIONS_COLOR, KEY_TABLEVIEW_TAG_BACKGROUND_INDEX} from "@/Const";

/**
 * 取tableview
 */
export const getTagBackgroundIndex = ()=>{
    let szIndex = localStorage.getItem(KEY_TABLEVIEW_TAG_BACKGROUND_INDEX);
    let nIndex = 0;
    if (szIndex){
        nIndex =  parseInt(szIndex) || 0;
    }
    nIndex = nIndex%ARRAY_PROPERTY_OPTIONS_COLOR.length;
    if (nIndex >= ARRAY_PROPERTY_OPTIONS_COLOR.length){
        nIndex = 0;
    }
    return nIndex;
}
export const setTagBackgroundIndexAdd = (nIndex:any)=>{
    localStorage.setItem(KEY_TABLEVIEW_TAG_BACKGROUND_INDEX,(nIndex+1)+'');
}